import React from "react";
import { Divider } from "@mui/material";
import { Button, Text } from "..";
import { HeaderWrapper, HeaderContent, 
    TextContainer, ButtonGroup, 
    ResponsiveText
} from "../../components/ImageCropModal//ModalCrop.style";

/** Hey there? hey dear? header? */
export const Header = ({ onCancel, onSave }) => {
    const baseButtonProps = {
        width: "140px",
        height: "38px",
        family: "Manrope",
        size: "14px",
        weight: "bold",
        boxShadow: "0px 3px 6px #00000029",
        style: { borderRadius: "7px" },
    };

    const baseTextProps = {
        family: "Manrope",
        color: "#11141A",
    };

    return (
        <HeaderWrapper>
            <HeaderContent>
                <TextContainer>
                    <Text
                        {...baseTextProps}
                        size="30px"
                        weight="bold"
                        lineHeight="24px"
                        noWrap
                    >
                        Media Editor
                    </Text>
                    <ResponsiveText {...baseTextProps} size="14px" lineHeight="20px">
                        Adjust your video using preset aspect ratios to suit your layout needs. Resize or reposition the crop box for the perfect fit.
                    </ResponsiveText>
                </TextContainer>

                <ButtonGroup>
                    <Button
                        {...baseButtonProps}
                        onClick={onCancel}
                        backgroundColor="#FFFFFF"
                        color="#000000"
                        border="1px solid #000000"
                    >
                        Cancel
                    </Button>
                    <Button
                        {...baseButtonProps}
                        onClick={onSave}
                        backgroundColor="#171A22"
                        color="white"
                    >
                      Save
                    </Button>
                </ButtonGroup>
            </HeaderContent>
            <Divider />
        </HeaderWrapper>
    );
};
